import {
  BulletedListIcon,
  CheckBoxIcon,
  CodeBlockIcon,
  DividerIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  Heading4Icon,
  Heading5Icon,
  Heading6Icon,
  NumberedListIcon,
  QuoteIcon,
  TextIcon,
} from '@blocksuite/affine-components/icons';
import type { EdgelessToolbarI18nKey } from '@blocksuite/affine-shared/services';
import type { NoteChildrenFlavour } from '@blocksuite/affine-shared/types';
import type { TemplateResult } from 'lit';

export const BUTTON_GROUP_LENGTH = 10;

export type NoteMenuItem = {
  icon: TemplateResult<1>;
  tooltipKey: EdgelessToolbarI18nKey;
  childFlavour: NoteChildrenFlavour;
  childType: string | null;
};

const LIST_ITEMS = [
  {
    flavour: 'affine:list',
    type: 'bulleted',
    icon: BulletedListIcon,
    tooltipKey: 'toolbar.bulletedList',
  },
  {
    flavour: 'affine:list',
    type: 'numbered',
    icon: NumberedListIcon,
    tooltipKey: 'toolbar.numberedList',
  },
  {
    flavour: 'affine:list',
    type: 'todo',
    icon: CheckBoxIcon,
    tooltipKey: 'toolbar.todoList',
  },
];

const TEXT_ITEMS = [
  {
    flavour: 'affine:paragraph',
    type: 'text',
    icon: TextIcon,
    tooltipKey: 'toolbar.text',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h1',
    icon: Heading1Icon,
    tooltipKey: 'toolbar.heading1',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h2',
    icon: Heading2Icon,
    tooltipKey: 'toolbar.heading2',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h3',
    icon: Heading3Icon,
    tooltipKey: 'toolbar.heading3',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h4',
    icon: Heading4Icon,
    tooltipKey: 'toolbar.heading4',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h5',
    icon: Heading5Icon,
    tooltipKey: 'toolbar.heading5',
  },
  {
    flavour: 'affine:paragraph',
    type: 'h6',
    icon: Heading6Icon,
    tooltipKey: 'toolbar.heading6',
  },
  {
    flavour: 'affine:code',
    type: 'code',
    icon: CodeBlockIcon,
    tooltipKey: 'toolbar.codeBlock',
  },
  {
    flavour: 'affine:paragraph',
    type: 'quote',
    icon: QuoteIcon,
    tooltipKey: 'toolbar.quote',
  },
  {
    flavour: 'affine:divider',
    type: null,
    icon: DividerIcon,
    tooltipKey: 'toolbar.divider',
  },
];

// TODO: add image, bookmark, database blocks
export const NOTE_MENU_ITEMS = TEXT_ITEMS.concat(LIST_ITEMS)
  .filter(item => item.type !== null)
  .map(item => {
    return {
      icon: item.icon,
      tooltipKey: item.tooltipKey,
      childFlavour: item.flavour as NoteChildrenFlavour,
      childType: item.type,
    } as NoteMenuItem;
  });
